import { createSelector } from "@reduxjs/toolkit";
import { choSearch, registQuery } from "../../functions/searchFunctions";
import { LOCALES } from "../../constants";
import { selectSchedulesState } from "./scheduleSelectors";
// import { loadData } from "../../functions/dataLoader";

// let schedules;

// loadData("schedules.json").then((data) => (schedules = data));
let isInitialized = false;

const selectLang = (state) => state.lang;

export const selectJourneyState = (state) => state.journeys;

export const selectJourneyEntities = (state) => selectJourneyState(state).entities;

export const selectJourneyIds = (state) => selectJourneyState(state).ids;

export const selectJourneyFilter = (state) => selectJourneyState(state).filter;

// 한 번만 계산하고 재사용
let subjugationNames, aganonNames, floraNames, kalaidNames;

// 성능 최적화: 초기 계산 결과 캐싱
const initializeRegionNames = (schedules) => {
    const subjugationNames = new Set([
        "스틸 컴 인 승리",
        "스틸 컴 인 패배",
        "노 포션, 노 패션! 승리",
        "노 포션, 노 패션! 패배",
        "레이더스 인카운터 승리",
        "레이더스 인카운터 패배",
        "슬라포칼립스 승리",
        "슬라포칼립스 패배",
        "런 어 웨이 솔저스 승리",
        "런 어 웨이 솔저스 패배",
    ]);

    const aganonNames = new Set();
    const floraNames = new Set();
    const kalaidNames = new Set();

    schedules.forEach((schedule) => {
        [...schedule.befores, ...schedule.currents, ...schedule.afters].forEach((block) => {
            if (block.region === "아가논") block.contents.forEach((c) => aganonNames.add(c));
            else if (block.region === "플로라") block.contents.forEach((c) => floraNames.add(c));
            else if (block.region === "칼라이드") block.contents.forEach((c) => kalaidNames.add(c));
        });
    });

    return { subjugationNames, aganonNames, floraNames, kalaidNames };
};

const filterByTab = (id, entity, tab) => {
    if (tab === "all") return true;
    else if (tab === "resette") return id.includes("리세트");
    else if (tab === "subjugation") return subjugationNames.has(id);
    else if (tab === "aganon") return aganonNames.has(id);
    else if (tab === "flora") return floraNames.has(id);
    else if (tab === "kalaid") return kalaidNames.has(id);
    else if (tab === "weather") return id.includes("오늘의 날씨");

    return false;
};

export const selectJourneysByTab = createSelector(
    [selectJourneyIds, selectJourneyEntities, selectJourneyFilter, selectSchedulesState],
    (ids, entities, filter, schedules) => {
        if (!isInitialized) {
            const all = [];
            Object.keys(schedules.entities).forEach((e) => all.push(...schedules.entities[e]));
            const names = initializeRegionNames(all);

            subjugationNames = names.subjugationNames;
            aganonNames = names.aganonNames;
            floraNames = names.floraNames;
            kalaidNames = names.kalaidNames;

            isInitialized = true;
        }
        return ids.filter((id) => filterByTab(id, entities[id], filter.tab.value));
    },
);

export const selectJourneysByQuery = createSelector(
    [selectJourneyEntities, selectLang, (_, query) => String(query).trim()],
    (entities, lang, query) => {
        if (query === "") return null;

        registQuery(lang.value, query);
        return Object.keys(entities).filter((id) => {
            const searchText = lang.value === LOCALES.KO ? entities[id].searchText : entities[id].searchText_ENG;
            return choSearch(searchText);
        });
    },
);

export const selectVisibleJourneyIds = createSelector([selectJourneysByTab, selectJourneysByQuery], (tabFilteredIds, queryFilteredIds) => {
    if (!queryFilteredIds) return tabFilteredIds;

    // const querySet = new Set(ids);
    // return tabFilteredIds.filter((id) => querySet.has(id));
    return queryFilteredIds;
});

export const selectWeatherJourneys = createSelector([selectJourneyEntities], (entities) =>
    Object.keys(entities).filter((id) => id.startsWith("오늘의 날씨")),
);
